import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pam-nom-wrap" }
const _hoisted_2 = { class: "pam-nom-title" }
const _hoisted_3 = { class: "pam-nom-title" }
const _hoisted_4 = { class: "pam-nom-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PamCardList = _resolveComponent("PamCardList")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxRequiredRuleStd = _resolveComponent("DxRequiredRuleStd")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxFormStd = _resolveComponent("DxFormStd")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxPopupStd = _resolveComponent("DxPopupStd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock(_component_PamCardList, {
          key: 0,
          items: _ctx.items,
          "title-field": { key: 'Nume' },
          fields: _ctx.cardFields,
          "empty-text": 'Niciun element.',
          onAdd: _ctx.onAdd,
          onEdit: _ctx.onEdit,
          onDelete: _ctx.onDelete
        }, null, 8, ["items", "fields", "onAdd", "onEdit", "onDelete"]))
      : (_openBlock(), _createBlock(_component_DxDataGrid, {
          key: 1,
          "data-source": _ctx.ds,
          "key-expr": "ID",
          height: "100%",
          "show-borders": true,
          "show-column-lines": false,
          "show-row-lines": true,
          "row-alternation-enabled": true,
          "hover-state-enabled": true,
          "column-auto-width": false,
          onInitNewRow: _ctx.onInitNewRow
        }, {
          editTitle: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxSelection, { mode: "single" }),
            _createVNode(_component_DxFilterRow, { visible: true }),
            _createVNode(_component_DxSearchPanel, {
              visible: true,
              placeholder: "Caută..."
            }),
            _createVNode(_component_DxPaging, { "page-size": 15 }),
            _createVNode(_component_DxSorting, { mode: "multiple" }),
            _createVNode(_component_DxEditing, {
              "allow-adding": true,
              "allow-updating": true,
              "allow-deleting": true,
              mode: "popup"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxPopup, {
                  "show-title": true,
                  width: 420,
                  height: "auto",
                  "title-template": "editTitle",
                  "close-on-outside-click": false
                }),
                _createVNode(_component_DxForm, { "col-count": 1 })
              ]),
              _: 1
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "ID",
              caption: "ID",
              width: 90,
              "allow-editing": false,
              visible: false,
              "form-item": { visible: false }
            }),
            (_ctx.marcaSource)
              ? (_openBlock(), _createBlock(_component_DxColumn, {
                  key: 0,
                  "data-field": "MarcaID",
                  caption: "Marcă"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxLookup, {
                      "data-source": _ctx.marcaSource,
                      "display-expr": "Nume",
                      "value-expr": "ID"
                    }, null, 8, ["data-source"]),
                    _createVNode(_component_DxRequiredRule, { message: "Marca este obligatorie" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_DxColumn, {
              "data-field": "Nume",
              caption: "Nume"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxRequiredRule, { message: "Numele este obligatoriu" })
              ]),
              _: 1
            }),
            (_ctx.showCod)
              ? (_openBlock(), _createBlock(_component_DxColumn, {
                  key: 1,
                  "data-field": "Cod",
                  caption: "Cod",
                  visible: false,
                  "form-item": { visible: false }
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_DxToolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, { name: "addRowButton" }),
                _createVNode(_component_DxItem, { name: "searchPanel" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-source", "onInitNewRow"])),
    _createVNode(_component_DxPopupStd, {
      visible: _ctx.popupVisible,
      "show-title": true,
      "full-screen": _ctx.isMobile,
      width: 420,
      height: "auto",
      "close-on-outside-click": false,
      "show-close-button": true,
      onHidden: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupVisible = false))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxFormStd, {
          ref: "formRef",
          "form-data": _ctx.formData,
          "col-count": 1,
          "label-location": "top"
        }, {
          default: _withCtx(() => [
            (_ctx.marcaSource)
              ? (_openBlock(), _createBlock(_component_DxSimpleItem, {
                  key: 0,
                  "data-field": "MarcaID",
                  label: { text: 'Marcă' },
                  "editor-type": "dxSelectBox",
                  "editor-options": { dataSource: _ctx.marcaSource, displayExpr: 'Nume', valueExpr: 'ID', searchEnabled: true }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRuleStd, { message: "Marca este obligatorie" })
                  ]),
                  _: 1
                }, 8, ["editor-options"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Nume",
              label: { text: 'Nume' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxRequiredRuleStd, { message: "Numele este obligatoriu" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DxButton, {
            text: "Salvează",
            type: "default",
            icon: "save",
            width: "120",
            disabled: _ctx.isSaving,
            onClick: _ctx.onSave
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(_component_DxButton, {
            text: "Anulează",
            type: "normal",
            "styling-mode": "outlined",
            width: "120",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupVisible = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible", "full-screen"])
  ]))
}